import styled from 'styled-components';

import { withOnboardingContext } from '../context/OnboardingProvider';
import { usePlanSync } from '../entitlements/usePlanSync';
import { useTenantSync } from '../entitlements/useTenantSync';

const WrapStyled = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  flex-direction: column;
`;

const WizardLayout = ({ children }: any) => {
  // The signup wizard sits outside `PrivateApp`, which is the app's only other
  // `usePlanSync` call site. Without this the plan store stays `null` for the whole
  // wizard, so every entitlement check on screen one resolves to 'loading' and the
  // Nexoya Starter channel allow-list cannot be applied where a team first connects a channel.
  // Both hooks ride `TEAM_QUERY` with its default options, sharing one observable with `Onboarding`.
  // `OnboardingProvider` passes `withOrg: false`, so that one stays a separate request.
  usePlanSync();
  // `OnboardingSocialProof` forks its testimonial on the tenant and lives under this layout.
  useTenantSync();

  return <WrapStyled>{children}</WrapStyled>;
};

export default withOnboardingContext(WizardLayout);
